import LocalGasStationOutlinedIcon from '@mui/icons-material/LocalGasStationOutlined';

const icons = { LocalGasStationOutlinedIcon };

// ==============================|| MENU ITEMS - FUEL CONSUMPTION MONITORING ||============================== //

const fuelConsumptionMonitoring = {
  id: 'group-fuel-consumption-monitoring',
  type: 'group',
  children: [
    {
      id: 'fuel-consumption-monitoring',
      title: 'Fuel Consumption Monitoring',
      type: 'collapse',
      icon: icons.LocalGasStationOutlinedIcon,
      children: [
        {
          id: 'vehicle-fuel-summary',
          title: 'Vehicle Fuel Summary',
          type: 'item',
          url: '/vehicle-fuel-summary',
          icon: icons.LocalGasStationOutlinedIcon
        },
        {
          id: 'daily-fuel-summary',
          title: 'Daily Vehicle Fuel Summary',
          type: 'item',
          url: '/daily-fuel-summary',
          icon: icons.LocalGasStationOutlinedIcon
        },
        {
          id: 'vehicle-fuel-history',
          title: 'Vehicle Fuel History',
          type: 'item',
          url: '/vehicle-fuel-history',
          icon: icons.LocalGasStationOutlinedIcon
        }
      ]
    }
  ]
};

export default fuelConsumptionMonitoring;
